import React from 'react';
import { DeploymentMonitor } from '../components/DeploymentMonitor';
import { useDeployments } from '../hooks/useDeployments';
import { useWorkflows } from '../hooks/useWorkflows';

export function MonitorPage() {
  const { deployments, loading: deploymentsLoading, cancelDeployment } = useDeployments({
    autoRefresh: true,
    refreshInterval: 5000, // More frequent updates for monitoring
  });

  const { workflows, loading: workflowsLoading } = useWorkflows({
    autoRefresh: true,
    refreshInterval: 5000,
  });

  const handleCancel = async (deploymentId: string) => {
    if (!confirm('Are you sure you want to cancel this deployment?')) return;

    try {
      await cancelDeployment(deploymentId);
      alert('Deployment cancelled successfully');
    } catch (err) {
      alert(`Failed to cancel deployment: ${err}`);
    }
  };

  const handleRetry = async (deploymentId: string) => {
    if (!confirm('Are you sure you want to retry this deployment?')) return;

    try {
      // Find the workflow and retry it
      const workflow = workflows.find((w) => w.params.deploymentId === deploymentId);
      if (workflow) {
        // This would call the retry workflow API
        alert('Retry functionality would be implemented here');
      }
    } catch (err) {
      alert(`Failed to retry deployment: ${err}`);
    }
  };

  const loading = deploymentsLoading || workflowsLoading;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Deployment Monitor</h1>
        <p className="mt-2 text-gray-600">
          Real-time monitoring of deployment status and workflows
        </p>
      </div>

      <DeploymentMonitor
        deployments={deployments}
        workflows={workflows}
        loading={loading}
        onCancel={handleCancel}
        onRetry={handleRetry}
      />
    </div>
  );
}
